import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { PreLoginAppStatusService } from './services/pre-login-app-status.service';
import { ApplicationRetrievalPayload } from './interfaces/request-payloads.interface';
import { ApplicationStatusItem } from './interfaces/response-payloads.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-pre-login-app-status',
    templateUrl: './pre-login-app-status.component.html',
    styleUrls: ['./pre-login-app-status.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class PreLoginAppStatusComponent extends GlobalShadowStyleDirective implements OnInit {
  appStatusResponseRetrieved: ApplicationStatusItem;
  noDataFoundContent: string;
  statusDataRetrieved: boolean = false;
  serviceCalled = false;

  form: UntypedFormGroup;

  constructor(
    private preLoginAppStatusService: PreLoginAppStatusService,
    private fb: UntypedFormBuilder
  ) {
    super()
    this.form = this.fb.group({
      applicationTrackingNumber: this.fb.control('', Validators.required),
      lastName: this.fb.control('', Validators.required)
    });
  }

  get getFormValuesAsJson(): {
    applicationTrackingNumber: string;
    lastName: string;
  } {
    return this.form.value as {
      applicationTrackingNumber: string;
      lastName: string;
    };
  }

  ngOnInit() { }

  triggerLoginModal() { }

  onChange() {
    // console.log(this.form);
    if (this.statusDataRetrieved === true) {
      this.serviceCalled = false;
      this.appStatusResponseRetrieved = null;
      this.statusDataRetrieved = false;
    }
  }

  async submit() {
    this.serviceCalled = true;

    const payload: ApplicationRetrievalPayload = {
      applicationTrackingNumber: this.getFormValuesAsJson.applicationTrackingNumber,
      lastName: this.getFormValuesAsJson.lastName
    };

    this.noDataFoundContent = null;

    const response: ApplicationStatusItem
      = await this.preLoginAppStatusService.getStatus(payload).catch(e => e);

    if (!(response instanceof HttpErrorResponse)) {
      if(response.billingFrequency === "SSA"){
        response.billingFrequency = "Social Security (SSA) Benefit Check";
      }else if(response.billingFrequency === "RRB"){
        response.billingFrequency = "Railroad Retirement Board (RRB) benefit check";
      }
      this.appStatusResponseRetrieved = response;
      this.statusDataRetrieved = true;
    } else {
      this.noDataFoundContent = 'We are unable to locate an application. Please verify the information and try again. If you need additional assistance, please see the Contact Us section.';
      this.serviceCalled = false;

      // this.appStatusResponseRetrieved = {
      //   downstreamTrackingStatus: 'Submitted / In Process',
      //   productDescription: 'This is the product',
      //   portalApplicationStatus: 'Submitted / In Process',
      //   creationDate: '08/04/2020',
      //   productType: 'MOCK BLUE',
      //   applicationTrackingId: '12121244',
      // };
    }

  }

}
